import React from 'react'
import { FaPlusSquare } from 'react-icons/fa'
import cn from 'classnames'

import 'components/graph/controls/controls.less'
import 'components/graph/controls/addNode.less'

type AddControlProps = {
  createAndFocusNode: (payload: Record<string, unknown>) => void
  isCreating: boolean
  isEditing: boolean
  control: string
}

const AddControl = ({ createAndFocusNode, isCreating, isEditing, control }: AddControlProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    if (isCreating || isEditing) {
      return
    }
    createAndFocusNode({})
  }

  return (
    <div className={cn('control', 'add-node')} data-graph-type="control" title={`+ Node (isolated) ${control}`}>
      <a className={cn('icon', { disabled: isCreating || isEditing })} onClick={handleClick}>
        <FaPlusSquare aria-hidden />
        <span className="sr-only">Create Node</span>
      </a>
    </div>
  )
}

export default AddControl
